import * as React from 'react';
import { ProductDetailFeatures } from './ProductDetailFeatures.js';
import { useProductData } from '../../../context/ProductContext.js';

const ProductDetailFeaturesContainer = ()=>{
    const { activeVariant: { productFeatures  } , colorFeatureIcons ,  } = useProductData();
    if (!productFeatures.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailFeatures, {
        productFeatures: productFeatures,
        colorFeatureIcons: colorFeatureIcons
    });
};

export { ProductDetailFeaturesContainer };
//# sourceMappingURL=ProductDetailFeaturesContainer.js.map
